import { apiClient } from "@/services/api";

export default {
  completeGuest(data) {
    return apiClient.post("/guest-induction", data);
  },
  complete(data) {
    return apiClient.post("/induction", data);
  },
  getResponse() {
    return apiClient.get("/user/induction");
  }
};
